import {ServiceModel} from "../core/service";
import {ServiceSet} from '../../collection/sets/service_set';

class AdminServiceModel extends ServiceModel {

    $update(data) {
        const post_data = {...data};

        // Only send who/what/where data if any of it actually changed
        if (
            post_data.person_ids &&
            post_data.resource_ids &&
            JSON.stringify(post_data.person_ids) === JSON.stringify(this._data.person_ids) &&
            JSON.stringify(post_data.resource_ids) === JSON.stringify(this._data.resource_ids)
        ) {

            delete post_data.resource_ids;
            delete post_data.person_ids;
        }

        return this.$put('self', {}, this.jsonify(post_data)).then((res) => {
                return this.constructor(res);
            }
        );
    }

    $delete() {
        this.$flush('self');
        return this.$del('self').then((res) => {
            ServiceSet.delete(this.self, this.company_id);
        });
    }

    $refetch() {
        return new Promise((resolve, reject) => {
            this.$flush('self');
            this.$get('self').then((res) => {
                    this.constructor(res);
                    return resolve(this);
                }
                , err => reject(err));
        });
    }
}

export {
    AdminServiceModel
}